import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LotusMatrix from "@/components/LotusMatrix";
import VentureIndex from "@/components/VentureIndex";
import CreditsSection from "@/components/CreditsSection";
import BackgroundSection from "@/components/BackgroundSection";
import BioStrip from "@/components/BioStrip";
import SiteFooter from "@/components/SiteFooter";
import MusicPage from "@/components/MusicPage";
import BooksPage from "@/components/BooksPage";
import { ArchFrieze, JaliRule, PaisleyRule, StarJaliRule, LotusPondRule, RosetteChain } from "@/components/Mughal";
import MotionBackdrop from "@/components/MotionBackdrop";

const Home = () => (
  <main className="min-h-screen bg-[#f6f1e5]">
    <LotusMatrix />
    {/* the gallery wing — deep walnut, Mughal ornament, motion art */}
    <div className="relative bg-[#1d1206]">
      <div className="pt-8 md:pt-12">
        <ArchFrieze className="text-[#d4af37]/60" />
      </div>
      <VentureIndex />
      <div className="mx-auto max-w-4xl px-6 py-8 md:py-12">
        <PaisleyRule className="text-[#d4af37]/45" />
      </div>
      {/* prose wing — credits, background and bio drift over living motion art */}
      <div className="relative">
        <MotionBackdrop dim={0.68} />
        <div className="relative">
          <CreditsSection />
          <div className="mx-auto max-w-4xl px-6 py-8 md:py-12">
            <StarJaliRule className="text-[#d4af37]/45" />
          </div>
          <BackgroundSection />
          <div className="mx-auto max-w-4xl px-6 py-8 md:py-12">
            <LotusPondRule className="text-[#d4af37]/45" />
          </div>
          <BioStrip />
        </div>
      </div>
      <div className="mx-auto max-w-2xl px-6 py-8 md:py-12">
        <RosetteChain className="text-[#d4af37]/45" />
      </div>
      <SiteFooter />
    </div>
    <div className="noise-overlay" aria-hidden="true" />
  </main>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/music" element={<MusicPage />} />
          <Route path="/books" element={<BooksPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
